<app-mediego-confirmation-dialog acceptLabel="{{ 'SHARED.QUIT_NO_SAVE_CONFIRMATION_DIALOG.ACCEPT_LABEL' | translate }}"
                                 declineLabel="{{ 'SHARED.QUIT_NO_SAVE_CONFIRMATION_DIALOG.DECLINE_LABEL' | translate }}">
  {{ 'SHARED.QUIT_NO_SAVE_CONFIRMATION_DIALOG.TITLE' | translate }}
</app-mediego-confirmation-dialog>
